<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 20:01:16
 * @LastEditTime: 2019-09-02 18:51:34
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="返利明细" name="1">
        <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
          <el-form-item label="到账时间" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form1.start_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form1.end_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="订单类型:">
            <el-select v-model="form1.is_parent">
              <el-option label="全部" value="0"></el-option>
              <el-option label="直属客户订单" value="1"></el-option>
              <el-option label="非直属客户订单" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号:">
            <el-input v-model="form1.settlement_order_sn" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onBtnSearch()" class="mr-10">搜索</el-button>
            <el-button type="primary" @click="onExport()">导出</el-button>
          </el-form-item>
        </el-form>
        <div
          style="margin-bottom:10px"
        >返利总额:{{parseFloat(total/100)}} ,返利余额:{{parseFloat(outstock/100)}}</div>

        <el-table
          ref="multipleTable"
          :data="tableData1"
          v-loading="loading"
          border
          stripe
          style="width: 100%;margin: 20px"
        >
          <el-table-column prop label="返利订单" fixed>
            <template slot-scope="scope">
              <router-link tag="span" to="next_order">{{scope.row.settlement_order_sn}}</router-link>
            </template>
          </el-table-column>
          <el-table-column prop label="订单类型" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.is_parent==1?"直属":"非直属"}}</template>
          </el-table-column>
          <el-table-column prop="total_fee" label="订单金额" show-overflow-tooltip>
            <template slot-scope="scope">{{parseFloat(scope.row.total_fee/100)}}</template>
          </el-table-column>
          <el-table-column prop="settlement_money" label="返利金额" show-overflow-tooltip>
            <template slot-scope="scope">{{parseFloat(scope.row.settlement_money/100)}}</template>
          </el-table-column>
          <el-table-column prop="created_at" label="到账时间" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :current-page="pageNo1"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize1"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize1"
        ></el-pagination>
      </el-tab-pane>
      <el-tab-pane label="结算记录" name="2">
        <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
          <el-form-item label="到账时间" style="text-align: center">
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="开始时间"
                v-model="form2.start_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                type="date"
                placeholder="结束时间"
                v-model="form2.end_time"
                style="width: 100%;"
              ></el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onBtnSearch()" class="mr-10">搜索</el-button>
            <el-button type="primary" @click="onExport()">导出</el-button>
          </el-form-item>
        </el-form>
        <div
          style="margin-bottom:10px"
        >结算: {{parseFloat(total/100)}} ,结算余额:{{parseFloat(outstock/100)}}</div>

        <el-table
          ref="multipleTable"
          :data="tableData2"
          v-loading="loading"
          border
          stripe
          style="width: 100%;margin: 20px"
        >
          <el-table-column prop="settlement_money" label="结算金额" fixed>
            <template slot-scope="scope">{{parseFloat(scope.row.settlement_money/100)}}</template>
          </el-table-column>
          <el-table-column prop="created_at" label="结算时间" show-overflow-tooltip></el-table-column>

          <el-table-column prop="remarks" label="备注" show-overflow-tooltip></el-table-column>
        </el-table>
        <el-pagination
          style="margin: 20px 0"
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pageNo2"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="pageSize2"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize2"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "goods-onput",
  data() {
    return {
      loading: false,
      activeName: "1",
      form1: {
        start_time: "",
        end_time: "",
        is_parent: "",
        settlement_order_sn:""
      },
      form2: {
        start_time: "",
        end_time: "",
        settlement_order_sn:""
      },
      tableData1: [],
      tableData2: [],
      total: 0,
      outstock: 0,
      //分页
      pageNo1: 1, //页码
      pageSize1: 20, //每页现实的条数
      totalSize1: 0, //总条数
      //分页
      pageNo2: 1, //页码
      pageSize2: 20, //每页现实的条数
      totalSize2: 0 //总条数
    };
  },
  methods: {
    getLastMonth() {
      var now = new Date();
      var year = now.getFullYear(); //getYear()+1900=getFullYear()
      var month = now.getMonth() + 1; //0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }
      dateObj.now = year + "-" + month + "-" + day;
      if (parseInt(month) == 1) {
        //如果是1月份，则取上一年的12月份
        dateObj.last = parseInt(year) - 1 + "-12-" + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate(); //上月总天数
      if (preSize < parseInt(day)) {
        //上月总天数<本月日期，比如3月的30日，在2月中没有30
        dateObj.last = year + "-" + month + "-01";
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + "-0" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      } else {
        dateObj.last = year + "-" + (parseInt(month) - 1) + "-" + day;
        return dateObj;
      }
    },
    onBtnSearch() {
      this.loading = true;
      if (this.activeName == 1) {
        let beginstr = "",
          endstr = "";
        if (this.form1.start_time) {
          this.form1.start_time = this.moment(this.form1.start_time).format(
            "YYYY-MM-DD"
          );
        }
        if (this.form1.end_time) {
          this.form1.end_time = this.moment(this.form1.end_time).format(
            "YYYY-MM-DD"
          );
        }
        this.$get("logistics_1", "/rebates/rebate", {
          ...this.form1,
          per_page: 10,
          page: 1,
          channel: 1,
          is_export: 0
        }).then(res => {
          this.loading = false;
          this.tableData1 = res.data;
          this.totalSize1 = res.meta.total;
          this.total = res.sum_data.count;
          this.outstock = res.sum_data.total_fee;
        });
      } else {
        let beginstr = "",
          endstr = "";
        if (this.form2.start_time) {
          this.form2.start_time = this.moment(this.form2.start_time).format(
            "YYYY-MM-DD"
          );
        }
        if (this.form2.end_time) {
          this.form2.end_time = this.moment(this.form2.end_time).format(
            "YYYY-MM-DD"
          );
        }
        this.$get("logistics_1", "/rebates/settlement", {
          ...this.form2,
          per_page: 10,
          page: 1,
          channel: 1,
          is_export: 0
        }).then(res => {
          this.loading = false;
          this.tableData2 = res.data;
          this.totalSize2 = res.meta.total;
          this.total = res.sum_data.count;
          this.outstock = res.sum_data.total_fee;
        });
      }
    },
    onSearch() {
      this.loading = true;
      if (this.activeName == 1) {
        let beginstr = "",
          endstr = "";
        if (this.form1.start_time) {
          this.form1.start_time = this.moment(this.form1.start_time).format(
            "YYYY-MM-DD"
          );
        }
        if (this.form1.end_time) {
          this.form1.end_time = this.moment(this.form1.end_time).format(
            "YYYY-MM-DD"
          );
        }
        this.$get("logistics_1", "/rebates/rebate", {
          ...this.form1,
          per_page: this.pageSize1,
          page: this.pageNo1,
          channel: 1,
          is_export: 0
        }).then(res => {
          this.loading = false;
          this.tableData1 = res.data;
          this.totalSize1 = res.meta.total;
          this.total = res.sum_data.count;
          this.outstock = res.sum_data.total_fee;
        });
      } else {
        let beginstr = "",
          endstr = "";
        if (this.form2.start_time) {
          this.form2.start_time = this.moment(this.form2.start_time).format(
            "YYYY-MM-DD"
          );
        }
        if (this.form2.end_time) {
          this.form2.end_time = this.moment(this.form2.end_time).format(
            "YYYY-MM-DD"
          );
        }
        this.$get("logistics_1", "/rebates/settlement", {
          ...this.form2,
          per_page: this.pageSize2,
          page: this.pageNo2,
          channel: 1,
          is_export: 0
        }).then(res => {
          this.loading = false;
          this.tableData2 = res.data;
          this.totalSize2 = res.meta.total;
          this.total = res.sum_data.count;
          this.outstock = res.sum_data.total_fee;
        });
      }
    },
    onExport() {
      let url = "",
        access_tokens = localStorage.getItem("access_token");
      if (process.env.NODE_ENV == "development") {
        url = "http://logistics.c.";
      } else if (process.env.NODE_ENV == "production") {
        url = "http://logistics.";
      } else {
        url = "http://logistics.c.";
      }
      if (this.activeName == 1) {
        let beginstr = "",
          endstr = "";
        if (this.form1.start_time) {
          beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
        }
        if (this.form1.end_time) {
          endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
        }
  
        window.open(
          process.env.VUE_APP_URL_V1 +
            "/rebates​/rebate.export?" +
            "lang=" +
            "" +
            "&is_export=1" +
            "&start_time=" +
            beginstr +
            "&end_time=" +
            endstr +
            "&settlement_order_sn=" +
            this.form1.settlement_order_sn +
            "&channel=1&is_parent="+
            this.form1.is_parent +
            "&signature="+
            this.$md5(access_tokens)
        );
      } else {
        let beginstr = "",
          endstr = "";
        if (this.form2.start_time) {
          beginstr = this.moment(this.form2.start_time).format("YYYY-MM-DD");
        }
        if (this.form2.end_time) {
          endstr = this.moment(this.form2.end_time).format("YYYY-MM-DD");
        }

        window.open(
          process.env.VUE_APP_URL_V1 +
            "/rebates/settlement.export?"+
            "lang=" +
            "" +
            "&is_export=1" +
            "&start_time=" +
            beginstr +
            "&channel=1&end_time=" +
            endstr+
            "&signature="+
            this.$md5(access_tokens)
        );
      }
    },
    handleClick(tab) {},
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.pageNo1 = 1;
      //this.getDealerList();
      this.onSearch();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      //this.getDealerList();
      this.onSearch();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.pageNo2 = 1;
      //this.getGoodsList();
      this.onSearch();
    },
    handleCurrentChange2(val) {
      this.pageNo2 = val;
      //this.getGoodsList();
      //this.getGoodsList();
      this.onSearch();
    },
    handleClick() {
      this.onSearch();
    }
  },
  created() {
    this.form2.start_time = this.getLastMonth().last;
    this.form2.end_time = this.getLastMonth().now;
    this.form1.start_time = this.getLastMonth().last;
    this.form1.end_time = this.getLastMonth().now;
    this.onSearch()
  }
};
</script>

<style lang="scss" scoped>
</style>